import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${API}/api/auth/login`, {
        username,
        password,
      });

      localStorage.setItem("adminAuth", "true");
      navigate("/admin");

    } catch {
      alert("Invalid credentials");
    }
  };

  return (
    <section className="pt-40 flex justify-center">
      <div className="w-full max-w-md bg-white p-8 rounded-3xl shadow-xl border">
        <h2 className="text-2xl font-bold mb-6 text-center">
          Admin Sign In
        </h2>

        <form onSubmit={handleLogin} className="space-y-5">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full p-3 rounded-xl border"
            required
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full p-3 rounded-xl border"
            required
          />

          <button
            type="submit"
            className="w-full py-3 rounded-xl text-white bg-blue-600"
          >
            Login
          </button>
        </form>
      </div>
    </section>
  );
}